import { Component } from '@angular/core';
import { EaccessAuthService } from '../auth/eaccess-auth.service';
import { ROLE_COMPLIANCE } from '../shared/constants';
import { Observable } from 'rxjs';

@Component({
  selector: 'eaa-can-validate-mappings',
  template: `
    @if (canView) {
      <ng-content></ng-content>
    }
  `
})
export class CanValidateMappingsComponent {
  public canView: boolean | null = null;

  constructor(private authService: EaccessAuthService) {}

  ngOnInit(): void {
    canValidateMappings$(this.authService).subscribe((hasRole) => (this.canView = hasRole));
  }
}

export function canValidateMappings$(authService: EaccessAuthService): Observable<boolean> {
  return authService.hasRole$(ROLE_COMPLIANCE);
}
